import React from 'react';
import './index.scss';

const StepProgress = ({ steps, currentStep, onChangeStep }) => {
  const { innerWidth } = window;
  return (
    <div className="step-progress">
      {steps.map((item, index) => (
        <div
          key={index}
          className="step-container"
          onClick={() => onChangeStep(index)}
        >
          <div className={`step-word ${index <= currentStep ? 'active' : ''}`}>
            {item}
          </div>
          {index < steps.length - 1 && (
            <div className="step-container">
              {Array.from({ length: innerWidth < 768 ? 1 : 5 }, (_, i) => (
                <div
                  key={i}
                  className={`step-dot ${index < currentStep ? 'active' : ''}`}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StepProgress;
